<template>
  <div v-if="errorIncognitoMode && !incognitoModeOn">
    <IncognitoModeComponent></IncognitoModeComponent>
  </div>
  <div v-else>
    <PaymentComponent></PaymentComponent>
  </div>
</template>

<script>
import PaymentComponent from '@/components/PaymentComponent'
import IncognitoModeComponent from '@/components/IncognitoModeComponent'
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'HomeView',
  components: {
    PaymentComponent,
    IncognitoModeComponent
  },
  data: () => ({
    params: '',
    color: '',
    gradient: ''
  }),
  computed: {
    ...mapState(['errorIncognitoMode']),
    incognitoModeOn() {
      return process.env.VUE_APP_INCOGNITO_MODE_ON?.toLowerCase() === 'true'
    }
  },
  created() {
    this.checkIncognitoMode()
    this.getParam()
    this.setIdSessionHash(this.params)
  },
  methods: {
    ...mapMutations(['setIdSessionHash', 'setColorSesion', 'setGradientSesion', 'checkIncognitoMode']),
    getParam() {
      if (this.$route.params.idSessionHash) {
        this.params = this.$route.params.idSessionHash
      }
      if (this.$route.query.color) {
        this.color = '#' + this.$route.query.color
        localStorage.setItem('IFRAME_BTN_COLOR', this.color)
      } else if (localStorage.getItem('IFRAME_BTN_COLOR')) {
        this.color = localStorage.getItem('IFRAME_BTN_COLOR')
      } else {
        this.color = '#4050B5'
      }
      this.setColorSesion(this.color)
      if (this.$route.query.gradient) {
        this.gradient = this.$route.query.gradient
        localStorage.setItem('IFRAME_GRADIENT_COLOR', this.gradient)
      } else if (localStorage.getItem('IFRAME_GRADIENT_COLOR')) {
        this.gradient = localStorage.getItem('IFRAME_GRADIENT_COLOR')
      } else {
        this.gradient = 'ffd200,1feaea'
      }
      this.setGradientSesion(this.gradient)
    }
  }
}
</script>